var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "44",
        "height": "44",
        "viewBox": "0 0 88 88",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "50%",
        "y1": "-29.875%",
        "x2": "50%",
        "y2": "100%",
        "id": "a"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorTop)",
        "offset": "0%"
      }
    }), _c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColotBot)",
        "offset": "100%"
      }
    })])]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('circle', {
      attrs: {
        "fill": "url(#a)",
        "cx": "44",
        "cy": "44",
        "r": "44"
      }
    }), _c('path', {
      attrs: {
        "d": "M28 28h32v32H28z"
      }
    }), _c('path', {
      attrs: {
        "d": "M47.581 47.107c.947-1.12 1.396-2.543 1.396-4.115 0-3.576-3.241-6.474-6.879-6.474-3.638 0-6.586 2.898-6.586 6.474s2.948 6.892 6.586 6.892c1.451 0 2.295-.325 3.384-1.107l4.149 4.497c.255.251 1.015-.369 1.272-.621l.338-.391c.257-.253.654-.687.397-.94l-4.057-4.215zm-3.113-17.82c.202.198.385.36.554.487 2.336 1.764 6.579 2.928 10.448 3.18.143.01.325.019.549.029a.55.55 0 01.516.56v11.473c0 2.728-1.125 5.589-2.937 7.55-.94 1.312-2.142 2.542-3.402 3.756-3.332 3.61-8.985 3.594-12.61.397a25.121 25.121 0 01-3.91-4.403A10.802 10.802 0 0131 45.168V33.563c0-.3.227-.548.516-.56.262-.01.474-.023.636-.034 3.89-.27 8.137-1.45 10.442-3.236a5.33 5.33 0 00.488-.439.975.975 0 011.388-.007h-.002zm-2.19 17.758a3.76 3.76 0 110-7.519 3.76 3.76 0 010 7.52z",
        "fill": "#FFF",
        "fill-rule": "nonzero"
      }
    })])]));
  }
};